export const RED_NUMBERS = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];
export const BLACK_NUMBERS = [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35];
export const MAX_ROULLETE_RESULTS = 6;

export const enum AdditionalAssetsValues {
    HLS = 'HLS_URL',
    MAIN_IMAGE_ROUNDED = 'MAIN_IMAGE_ROUNDED',
    MOBILE_IMAGE_ROUNDED = 'MOBILE_IMAGE_ROUNDED',
    LIVE_DATA_TYPE = 'LIVE_DATA_TYPE',
    WC_REPLACER_ID = 'WC_REPLACER_ID',
    GAME_LIVE_TYPE = 'GAME_LIVE_TYPE'
}

export const enum LiveDataTypes {
    BLACKJACK = 'Blackjack',
    ROULETTE = 'Roulette',
    BACCARAT = 'Baccarat'
}
